import {BaseElement, BASIS, OSkinableInit} from "back/commons/basis";
import {IItemUiEnv, installSrcViewFileDrop} from "back/wsp/views/itemMain";
import {IReg, REG} from "lib/commons/registry";
import {IView} from "lib/commons/views";
import {JSX} from "lib/commons/xml/dom";
import {DOMSH} from "lib/commons/xml/domsh";
import {JWspUriChangeMsg, WSP} from "lib/wsp/wsp";
import {ImgSize, OImgSizeConfig} from "back/wsp/widgets/imgSize";
import {SRC} from "lib/wsp/src";

/**
 * View du contenu d'un item via une iframe (pdf...).
 *
 * Config attributes:
 */
export interface OItemIframeInit extends OSkinableInit {
	reg?: IReg<IItemUiEnv>
	transform?: string,
	size: OImgSizeConfig
}

export interface ItemIframe extends BaseElement {
	initialize(init: OItemIframeInit): this;
}

export class ItemIframe extends BaseElement implements IView {
	reg: IReg<IItemUiEnv>;

	_initialize(init: OItemIframeInit) {
		this.reg = this.findReg(init);
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		installSrcViewFileDrop(this.reg, this);
		const { env } = this.reg;
		const iframe = <iframe src={this.getStreamUrl(this.reg.env, init.transform)}/>;
		if (init.size) sr.appendChild(<ImgSize î={BASIS.newInit(init.size, this.reg)}>{iframe}</ImgSize>);
		else sr.appendChild(iframe);

		// Listener sur les changements de la ressource
		env.place.eventsMgr.on("wspUriChange", (msg: JWspUriChangeMsg) => {
			if (SRC.srcRef(env.longDesc) === SRC.srcRef(msg)) {
				iframe.contentWindow.location.reload();
			}
		});
	}

	getStreamUrl(env: IItemUiEnv, transform: string) {
		return WSP.getStreamStampedUrl(env.wsp, env.itemType.getMainStreamSrcUri(env.longDesc), env.longDesc.srcDt, transform)
	}
}

REG.reg.registerSkin("wsp-item-iframe", 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex: 1;
		flex-direction: column;
		padding: 1px;
	}

	:host > iframe {
		width: 100%;
		height: 100%;
	}
	
	iframe {
		border: none;
	}

	wsp-imgsize {
		flex: 1;
	}
`);


customElements.define("wsp-item-iframe", ItemIframe);
